<template>
    <div class="full-top">
        <div class="top" >
            <div class="container">
                <router-link
                        class="logo"
                        :to="'/'">
                    <img class="img-fluid" src="/static/img/logo.jpg"/>
                </router-link>

                <div class="top-right">
                    <a href="tel:+4860032 709" class="item">
                        <span class="icon-phone1"></span>
                        +48 600 325 709
                    </a>
                    <a href="mailto:jaroslaw.olszewski62@gmail.com" class="item">
                        <span class="icon-envelope1"></span>
                        jaroslaw.olszewski62@gmail.com
                    </a>
                </div>
            </div>
        </div>
        <div class="menu">
            <div class="container">
                <div class="jsMenu d-block d-md-none">MENU</div>
                <ul class="menu-content">
                    <li>
                        <router-link
                                class="link-menu"
                                v-bind:class="{ active: $route.name == 'home'}"
                                :to="'/'">
                            Strona główna
                        </router-link>
                    </li>
                    <li>
                        <router-link
                                class="link-menu "
                                v-bind:class="{ active: $route.name == 'judaszowce'}"
                                :to="'/judaszowce-cercises'">
                            Judaszowce Cercises
                        </router-link>
                    </li>
                    <li>
                        <router-link
                                class="link-menu "
                                v-bind:class="{ active: $route.name == 'szpalery'}"
                                :to="'/szpalery-formowane'">
                            Szpalery formowane
                        </router-link>
                    </li>
                    <li>
                        <router-link
                                class="link-menu "
                                v-bind:class="{ active: $route.name == 'asortyment'}"
                                :to="'/asortyment'">
                            Asortyment
                        </router-link>
                    </li>
                    <li>
                        <router-link
                                class="link-menu "
                                v-bind:class="{ active: $route.name == 'galeria'}"
                                :to="'/galeria'">
                            Galeria
                        </router-link>
                    </li>
                    <li>
                        <router-link
                                class="link-menu "
                                v-bind:class="{ active: $route.name == 'kontakt'}"
                                :to="'/kontakt'">
                            Kontakt
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {

    },
    watch:{
        $route (to, from){
            document.querySelector('.menu .menu-content').classList.remove('show');
        }
    },
    mounted(){
        function classToggle() {
            document.querySelector('.menu .menu-content').classList.toggle('show');
        }

        document.querySelector('.jsMenu').addEventListener('click', classToggle);


    },

}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Navbar.vue